/**
 * Created by bartdecorte on 26/03/16.
 */

class RowDrag {
  constructor(params) {
    this.INSERTDELAY = 500;
    this.insertTimers = [];

    this.params = {
      type: typeof params.type !== typeof undefined ? params.type : 'column',
      callback:
        typeof params.callback !== typeof undefined
          ? params.callback
          : () => {},
      $row: params.$row,
      $droppable: params.$droppable,
      dragEnterCallback:
        typeof params.dragEnterCallback !== typeof undefined
          ? params.dragEnterCallback
          : () => {},
      dragLeaveCallback:
        typeof params.dragLeaveCallback !== typeof undefined
          ? params.dragLeaveCallback
          : () => {},
      dragEndCallback:
        typeof params.dragEndCallback !== typeof undefined
          ? params.dragEndCallback
          : () => {},
      moveOnDrop:
        typeof params.moveOnDrop !== typeof undefined
          ? params.moveOnDrop
          : true,
      clearSpacers:
        typeof params.clearSpacers !== typeof undefined
          ? params.clearSpacers
          : () => {},
      appendableSelector: params.appendableSelector,
    };

    if (!this.params.$row.is('[draggable="true"]')) {
      return;
    }

    params.ev.originalEvent.dataTransfer.setData('foo', 'bar'); // Hack to make dragging work in Firefox

    this.params.mouse = {
      x: params.ev.originalEvent.clientX,
      y: params.ev.originalEvent.clientY + $(document).scrollTop(),
    };

    setTimeout(() => {
      this.params.$row.addClass('dragged');
    }, 100);

    this.rowHeight = this.params.$row.outerHeight();
    this.tolerance = this.rowHeight / 2;
    this.typePlural = this.params.type + 's';
    this.dragEnters = 0;

    this.setDraggingState(true);
    this.calculateInitialIndex();
    this.calculateYOffsets();
    this.bindListeners();
  }

  siblingSelector() {
    return (
      '[draggable]:not(.' +
      this.params.type +
      '-deleted):not(#' +
      this.params.type +
      '-row-proto)'
    );
  }

  getSiblings($droppable) {
    const selector = this.siblingSelector();
    if (typeof $droppable === typeof undefined)
      return this.droppable().find(selector);

    return $droppable.find(selector);
  }

  droppable() {
    if (typeof this.params.$droppable !== typeof undefined) {
      return this.params.$droppable;
    }

    return this.params.$row.parents('.droppable').first();
  }

  calculateInitialIndex() {
    const $siblings = $(this.getSiblings());
    this.initialIndex =
      $siblings.index(this.params.$row) +
      this.precedingDroppableCount(this.params.$row);
    this.currentInsertAt = this.initialIndex;
  }

  calculateYOffsets() {
    let scope = this;

    this.yOffsets = [];
    const $droppables = this.droppable();

    for (let i = 0; i < $droppables.length; i++) {
      let $siblings = this.getSiblings($($droppables[i]));

      if ($siblings.length < 1) {
        let $droppable = $($droppables[i]);
        let verticalBottom =
          $droppable.offset().top + Math.round($droppable.outerHeight());
        let verticalTop = verticalBottom - Math.round($droppable.outerHeight());
        this.yOffsets.push({
          y1: verticalTop - scope.tolerance,
          y2: verticalBottom + scope.tolerance,
        });
      }

      for (let j = 0; j < $siblings.length; j++) {
        let verticalBottom;
        let $sibling = $($siblings[j]);
        if (j === 0) {
          verticalBottom =
            $sibling.offset().top + Math.round($sibling.outerHeight());
          let verticalTop = verticalBottom - Math.round($sibling.outerHeight());
          this.yOffsets.push({
            y1: verticalTop - scope.tolerance,
            y2: verticalTop + scope.tolerance,
          });
        }
        verticalBottom =
          $sibling.offset().top + Math.round($sibling.outerHeight());
        this.yOffsets.push({
          y1: verticalBottom - scope.tolerance,
          y2: verticalBottom + scope.tolerance,
        });
      }
    }
  }

  bindListeners(ev) {
    const $droppable = this.droppable();
    $(document).on('drop', (ev) => {
      this.lDrop(ev);
    });
    $droppable.on('dragend', (ev) => {
      this.lDragEnd(ev);
    });
    $droppable.on('dragenter', (ev) => {
      this.dragEnters++;
      const $droppables = this.droppable();
      for (let i = 0; i < $droppables.length; i++) {
        this.params.dragLeaveCallback($($droppables[i]));
      }
      this.params.dragEnterCallback(this.parentDroppable($(ev.target)));
    });
    $droppable.on('dragleave', (ev) => {
      this.dragEnters--;
      if (this.dragEnters < 1)
        this.params.dragLeaveCallback(this.parentDroppable($(ev.target)));
    });
    $droppable.on('dragover', (ev) => {
      this.lCancelEvent(ev);
    });
    $(document).on('dragover', (ev) => {
      this.lDrag(ev);
    });
  }

  detachListeners() {
    this.droppable()
      .off('drag')
      .off('dragend')
      .off('dragenter')
      .off('dragleave')
      .off('dragover');
    $(document)
      .off('dragover')
      .off('drop');
  }

  lDrag(ev) {
    let mouse = {
      x: ev.originalEvent.clientX,
      y: ev.originalEvent.clientY + $(document).scrollTop(),
    };

    let y = mouse.y;

    let match = null;
    let i = 0;
    let item;
    while (match === null && i < this.yOffsets.length) {
      item = this.yOffsets[i];

      if (y >= item.y1 && y <= item.y2) match = i;

      i++;
    }

    if (match === null || match !== this.previousIndex) {
      for (i = 0; i < this.insertTimers.length; i++) {
        clearTimeout(this.insertTimers[i]);
      }
      this.previousIndex = match;
    }

    if (this.currentInsertAt !== match) {
      this.insertTimers.push(
        setTimeout(() => {
          this.handleInsert(match);
        }, this.INSERTDELAY)
      );
    }
  }

  lDrop(ev) {
    const $droppable = this.parentDroppable($(ev.target));

    if (this.currentInsertAt !== null) {
      let siblings = this.getSiblings($droppable);
      let to = this.currentInsertAt;

      const precedingGroupsForIndex = this.precedingGroupsForIndex(to);
      const precedingSiblingsForIndex = this.precedingSiblingsForIndex(to);
      const correctedIndex =
        to - precedingGroupsForIndex - precedingSiblingsForIndex;

      if (this.params.moveOnDrop) {
        if (correctedIndex !== 0) {
          $(siblings[correctedIndex - 1]).after(this.params.$row);
        } else {
          $(siblings[correctedIndex]).before(this.params.$row);
        }
      }

      const from = this.initialIndex;
      if (from < to) {
        to--;
      }

      this.clearSpacers();

      for (let i = 0; i < this.insertTimers.length; i++) {
        clearTimeout(this.insertTimers[i]);
      }

      this.resetDraggedItem();
      this.detachListeners();
      this.setDraggingState(false);
      this.params.callback(from, to, this.shiftedIndices(from, to), $droppable);
    }
  }

  lDragEnd(ev) {
    this.resetDraggedItem();
    this.clearSpacers();
    this.setDraggingState(false);
    this.params.dragEndCallback();
  }

  lCancelEvent(ev) {
    ev.preventDefault();
    return false;
  }

  clearSpacers() {
    this.params.$row
      .parent()
      .children('.spacer')
      .detach();
    this.params.clearSpacers();
  }

  resetDraggedItem() {
    if (this.params.$row.hasClass('dragged'))
      this.params.$row.removeClass('dragged');
  }

  handleInsert(index) {
    this.currentInsertAt = index;
    const precedingGroupsForIndex = this.precedingGroupsForIndex(index);
    const precedingSiblingsForIndex = this.precedingSiblingsForIndex(index);
    const correctedIndex =
      index - precedingGroupsForIndex - precedingSiblingsForIndex;

    for (let i = 0; i < this.insertTimers.length; i++) {
      clearTimeout(this.insertTimers[i]);
    }

    let siblings = this.getSiblings();
    const cellCount = $(siblings[0]).find('td').length;

    this.clearSpacers();
    const styles = ['pointer-events: none', `height: ${this.rowHeight}px`];
    const $elt = $(
      `<tr class="spacer" style="${styles.join(
        '; '
      )}"><td colspan="${cellCount}"></td></tr>`
    );

    if (this.droppable().length > 1) {
      let $targetDroppable = $(this.droppable()[precedingGroupsForIndex]);
      if (typeof this.params.appendableSelector !== typeof undefined) {
        $targetDroppable = $targetDroppable.find(
          this.params.appendableSelector
        );
      }

      if (correctedIndex == 0) {
        $targetDroppable.prepend($elt);
      } else {
        let siblings = this.getSiblings($targetDroppable);
        $(siblings[correctedIndex - 1]).after($elt);
      }
    } else {
      if (index < siblings.length) {
        $(siblings[index]).before($elt);
      } else {
        $(siblings[siblings.length - 1]).after($elt);
      }
    }

    setTimeout(() => {
      this.calculateYOffsets();
    }, 300);
  }

  shiftedIndices(from, to) {
    if (from === to) return {};

    const changes = {};

    const min = Math.min(from, to);
    const max = Math.max(from, to);

    for (let i = min; i <= max; i++) {
      if (i != from) changes[i] = i + (from > to ? 1 : -1);
    }
    changes[from] = to;

    return changes;
  }

  parentDroppable($elt) {
    while (this.droppable().index($elt) < 0) {
      if ($elt.get(0).tagName === 'BODY') return;

      $elt = $elt.parent();
    }

    return $elt;
  }

  precedingDroppableCount($elt) {
    const $currentDroppable = this.parentDroppable($elt);
    const $allDroppables = this.droppable();
    return $allDroppables.index($currentDroppable);
  }

  multiDroppableCorrection(index) {
    const $droppables = this.droppable();
    let correction = 0;
    let i = 0;
    let j = 0;
    while (i < index && j < $droppables.length) {
      let $droppable = $($droppables[j]);
      let $draggables = $droppable.find(this.siblingSelector());
      if (index - i >= $draggables.length) {
        correction -= 1;
        correction -= $draggables.length;
      }
      j += 1;
      i += 1;
      i += $draggables.length;
    }
    return correction;
  }

  precedingGroupsForIndex(index) {
    const $droppables = this.droppable();
    let correction = 0;
    let i = 0;
    let j = 0;
    while (i < index && j < $droppables.length) {
      let $droppable = $($droppables[j]);
      let $draggables = $droppable.find(this.siblingSelector());
      if (index - i > $draggables.length) {
        correction += 1;
      }
      j += 1;
      i += 1;
      i += $draggables.length;
    }
    return correction;
  }

  precedingSiblingsForIndex(index) {
    const $droppables = this.droppable();
    let correction = 0;
    let i = 0;
    let j = 0;
    while (i < index && j < $droppables.length) {
      let $droppable = $($droppables[j]);
      let $draggables = $droppable.find(this.siblingSelector());
      if (index - i > $draggables.length) {
        correction += $draggables.length;
      }
      j += 1;
      i += 1;
      i += $draggables.length;
    }
    return correction;
  }

  setDraggingState(isDragging) {
    const $body = $('body');
    if (isDragging && !$body.hasClass('dragging')) {
      $body.addClass('dragging');
    } else if (!isDragging && $body.hasClass('dragging')) {
      $body.removeClass('dragging');
    }
    return this;
  }
}

export default RowDrag;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/RowDrag.js